import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { OnboardingService } from './onboarding.service';

@Injectable({
    providedIn: 'root',
})
export class OnboardingWizardService {
    private showWizardSubject = new BehaviorSubject<boolean>(false);
    public showWizard$ = this.showWizardSubject.asObservable();

    private readonly WIZARD_DISMISSED_KEY = 'vendostack_onboarding_wizard_dismissed';

    constructor(private onboardingService: OnboardingService) {}

    /**
     * Initialize and check if wizard should be shown
     */
    initialize(): void {
        // Check if wizard was previously dismissed in this browser session
        const dismissed = localStorage.getItem(this.WIZARD_DISMISSED_KEY);

        if (dismissed === 'true') {
            return;
        }

        // Fetch onboarding progress
        this.onboardingService.getProgress().subscribe(progress => {
            // Show wizard if not completed and not previously dismissed
            if (!progress.wizardCompleted) {
                setTimeout(() => {
                    this.showWizardSubject.next(true);
                }, 1000); // Delay to allow app to fully load
            }
        });
    }

    /**
     * Show the wizard manually
     */
    showWizard(): void {
        this.showWizardSubject.next(true);
    }

    /**
     * Hide the wizard
     */
    hideWizard(): void {
        this.showWizardSubject.next(false);
    }

    /**
     * Dismiss wizard temporarily (this session only)
     */
    dismissWizard(): void {
        localStorage.setItem(this.WIZARD_DISMISSED_KEY, 'true');
        this.hideWizard();
    }

    /**
     * Complete wizard and hide it
     */
    completeWizard(): void {
        this.onboardingService.completeWizard().subscribe(() => {
            localStorage.setItem(this.WIZARD_DISMISSED_KEY, 'true');
            this.hideWizard();
        });
    }
}

